import dynamic from "next/dynamic";
import SalesPhoneEnterpriseConfig from "./sales-phone-enterprise-config";
import SalesPhoneEnterpriseAdvancedConfig from "./sales-phone-enterprise-advanced-config";
const SalesPhoneEnterpriseComponent = dynamic(()=>import("./sales-phone-enterprise-component"));
export default {
    SalesPhoneEnterpriseComponent,
    SalesPhoneEnterpriseConfig,
    SalesPhoneEnterpriseAdvancedConfig
};
